<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <button type="button" routerLink="/retail/compliance"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer;"
      onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">arrow_back</mat-icon>
      Regresar
    </button>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Compliance Usuario</h1>
  </div>

  <mat-tab-group>
    <!-- Tab 1: Datos generales / Datos representante legal -->
    <mat-tab [label]="!isCompany ? 'Datos generales' : 'Datos representante legal'">
      <div *ngIf="user" class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mt-4">
        <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
          <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">person</mat-icon>
            {{ !isCompany ? 'Datos Generales' : 'Datos Representante Legal' }}
          </h2>
        </div>
        <div class="p-5">
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Nombre</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ user.nombre }}</p>
            </div>
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Apellidos</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ user.apellidos }}</p>
            </div>
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Documento</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ user.tipoId }} {{ user.numeroId }}</p>
            </div>
            <div *ngIf="!isCompany">
              <span class="text-gray-400 text-xs font-semibold uppercase">Fecha de nacimiento</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ user.fechaNacimiento }}</p>
            </div>
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Teléfono</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ user.prefijoTelefono }} {{ user.telefono }}</p>
            </div>
            <div *ngIf="!isCompany">
              <span class="text-gray-400 text-xs font-semibold uppercase">Nacionalidad</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ user.nacionalidad }}</p>
            </div>
            <div *ngIf="!isCompany">
              <span class="text-gray-400 text-xs font-semibold uppercase">País residencia</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ user.paisResidencia }}</p>
            </div>
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Correo</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ user.email }}</p>
            </div>
            <div *ngIf="!isCompany">
              <span class="text-gray-400 text-xs font-semibold uppercase">Profesión</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ user.profesion }}</p>
            </div>
          </div>

          <!-- Documento identidad -->
          <div class="mt-6 flex flex-col items-center" *ngIf="idImagesLoaded">
            <ng-container *ngIf="mostarFrontal">
              <h3 class="text-sm font-bold text-gray-700 mb-3">Documento identidad frontal</h3>
              <img *ngIf="fotoIdFrontal" class="sm:w-4/6 md:w-1/2 rounded-lg border border-gray-200" [src]="fotoIdFrontal" (error)="fotoIdFrontal = ''" />
              <div *ngIf="!fotoIdFrontal" style="display: flex; align-items: center; gap: 8px; padding: 16px 20px; background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 8px; margin-top: 8px;">
                <mat-icon style="color: #9ca3af;">image_not_supported</mat-icon>
                <span style="color: #9ca3af;">No está registrada la imagen</span>
              </div>
            </ng-container>
            <ng-container *ngIf="!mostarFrontal">
              <h3 class="text-sm font-bold text-gray-700 mb-3">Documento identidad posterior</h3>
              <img *ngIf="fotoIdPosterior" class="sm:w-4/6 md:w-1/2 rounded-lg border border-gray-200" [src]="fotoIdPosterior" (error)="fotoIdPosterior = ''" />
              <div *ngIf="!fotoIdPosterior" style="display: flex; align-items: center; gap: 8px; padding: 16px 20px; background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 8px; margin-top: 8px;">
                <mat-icon style="color: #9ca3af;">image_not_supported</mat-icon>
                <span style="color: #9ca3af;">No está registrada la imagen</span>
              </div>
            </ng-container>
            <button type="button" (click)="mostarFrontal = !mostarFrontal" class="mt-4"
              style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
              onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">rotate_right</mat-icon>
              Girar
            </button>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Tab 2: Datos empresa (solo isCompany) -->
    <mat-tab label="Datos empresa" *ngIf="isCompany">
      <div *ngIf="user" class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mt-4">
        <div style="background: linear-gradient(135deg, #fefce8, #fef9c3); padding: 16px 24px; border-bottom: 2px solid #fde68a;">
          <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #92400e; display: flex; align-items: center; gap: 8px;">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #92400e;">business</mat-icon>
            Datos Empresa
          </h2>
        </div>
        <div class="p-5">
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Nombre o razón social</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ user.razonSocial }}</p>
            </div>
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Nombre comercial</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ user.nombreComercial }}</p>
            </div>
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Rut</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ user.rutEmpresa }}</p>
            </div>
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Domicilio fiscal</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ user.domicilioFiscal }}</p>
            </div>
          </div>
          <div class="flex flex-wrap gap-3 pt-3 border-t border-gray-100">
            <button type="button" (click)="openTab(estatuto)"
              style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
              onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">description</mat-icon>
              Estatuto
            </button>
            <button type="button" (click)="openTab(documentoIdTributario)"
              style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
              onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">badge</mat-icon>
              Identificación Tributaria
            </button>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Tab 3: KYC -->
    <mat-tab label="KYC">
      <div *ngIf="user" class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mt-4">
        <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
          <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">verified_user</mat-icon>
            Know Your Customer
          </h2>
        </div>
        <div class="p-5">
          <form class="grid grid-cols-1 sm:grid-cols-2 gap-6" [formGroup]="formCompliance" *ngIf="formCompliance">
            <!-- Estado y acciones -->
            <div>
              <div class="mb-4">
                <span class="text-gray-400 text-xs font-semibold uppercase">Estado Compliance</span>
                <p class="text-gray-800 font-bold mt-1 text-base">{{ user.estadoCompliance.descripcion }}</p>
              </div>
              <div class="flex flex-wrap gap-3">
                <button type="button" (click)="aproveCompliance()" [disabled]="user.estadoComplianceID === 3"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
                  [style.opacity]="user.estadoComplianceID === 3 ? '0.4' : '1'"
                  [style.cursor]="user.estadoComplianceID === 3 ? 'not-allowed' : 'pointer'"
                  onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
                  <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">check</mat-icon>
                  Aprobar
                </button>
                <button type="button" (click)="rejectUser()" [disabled]="user.estadoComplianceID === 1"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: #dc2626; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
                  [style.opacity]="user.estadoComplianceID === 1 ? '0.4' : '1'"
                  [style.cursor]="user.estadoComplianceID === 1 ? 'not-allowed' : 'pointer'"
                  onmouseover="this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
                  <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">cancel</mat-icon>
                  Rechazar
                </button>
                <button type="button" (click)="backlistUser()" [disabled]="user.estadoComplianceID === 2"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: #92400e; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
                  [style.opacity]="user.estadoComplianceID === 2 ? '0.4' : '1'"
                  [style.cursor]="user.estadoComplianceID === 2 ? 'not-allowed' : 'pointer'"
                  onmouseover="this.style.background='#78350f'" onmouseout="this.style.background='#92400e'">
                  <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">error</mat-icon>
                  Black list
                </button>
              </div>
            </div>
            <!-- Checks -->
            <div>
              <div class="space-y-3">
                <p><mat-checkbox formControlName="politicamenteExpuesto">PEP</mat-checkbox></p>
                <p><mat-checkbox formControlName="esRTP">RTP</mat-checkbox></p>
                <p><mat-checkbox formControlName="esListaONU">LISTA ONU</mat-checkbox></p>
              </div>
              <mat-hint class="text-xs text-gray-400" *ngIf="user.fuenteComplianceID === 2">
                *Información traída de REGCHEQ
              </mat-hint>
              <div class="mt-4">
                <button type="button" (click)="guardarCompliance()"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
                  onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
                  <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">save</mat-icon>
                  Guardar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </mat-tab>

    <!-- Tab 4: Datos residenciales (solo !isCompany) -->
    <mat-tab label="Datos residenciales" *ngIf="!isCompany">
      <div *ngIf="user" class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mt-4">
        <div style="background: linear-gradient(135deg, #fdf4ff, #fae8ff); padding: 16px 24px; border-bottom: 2px solid #e9d5ff;">
          <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #6b21a8; display: flex; align-items: center; gap: 8px;">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #6b21a8;">home</mat-icon>
            Datos Residenciales
          </h2>
        </div>
        <div class="p-5">
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">País residencia</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ user.paisResidencia }}</p>
            </div>
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Ciudad de residencia</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ user.ciudadResidencia }}</p>
            </div>
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Dirección</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ user.direccion }}</p>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
